import React, { Fragment, useState, useEffect } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AiOutlinePercentage, AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';

import '../../../containers/Dashboard/dashboard.css';

const Rates = ( { rates, title } ) => {
    const [ todaysRates, setTodaysRates ] = useState( null );
    const [ todaysDate, setTodaysDate ] = useState( null );
    
    const formatDate = ( d ) => {
        const date = new Date( d + 'T12:00:00' );
        const options = { month: 'short', day: 'numeric' };
        return date.toLocaleDateString( 'en-US', options );
    };

    useEffect( () => {
        console.log( 'rates', rates );
        rates.sort( ( a, b ) => new Date( b.date ) - new Date( a.date ) );
        
        if ( rates.length ) {
            const d = rates[0].date;
            const tr = rates.filter( f => f.date === d );

            const list = {};
            tr.forEach( r => {
                list[r.program] = {
                    rate: r.rate,
                    change: r.change
                };
            } );
            setTodaysRates( list );
            setTodaysDate( d );
        }
    }, [ rates ] );

    
    return (
        <Fragment>
            {
                todaysRates ? (
                    <Row className='mx-2 align-items-center'>
                        <Col className='p-2'>
                            <AiOutlinePercentage className='tf-dashboard-section-header-title' />
                            <span className='ps-2'>{title} as of {formatDate( todaysDate )}</span>
                        </Col>
                        {
                            Object.keys( todaysRates ).map( ( program, idx ) => (
                                <Col key={idx} className='p-2'>
                                    <Row>
                                        <Col>
                                            <span className='fw-bold'>{program}</span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='auto' className='pe-1'>
                                            <span>{todaysRates[program].rate}</span>
                                        </Col>
                                        <Col xs='auto' className='fst-italic ps-1'>
                                            (<span>
                                                {
                                                    todaysRates[program].change.match( '-' ) ? (
                                                        <AiOutlineArrowDown color='green' />
                                                    ) : (
                                                        <AiOutlineArrowUp color='red' />
                                                    )
                                                }
                                            </span>
                                            <span>{todaysRates[program].change}</span>)
                                        </Col>
                                    </Row>
                                </Col>
                            ) )
                        }
                    </Row>
                ) : (
                    null
                )
            }
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    rates: state.user.rates
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Rates );